type Props = {
  width?: string;
  height?: string;
  viewBox?: string;
  fillColor?: string;
};

/**
 * YouTube Shorts "Remix" rail glyph — two opposing circular arrows with a
 * plus sign in the center. Filled icon so it reads uniformly with the rest
 * of the rail's icons.
 */
const YouTubeRemixIcon = (props: Props) => {
  const {
    width = '24',
    height = '24',
    viewBox = '0 0 24 24',
    fillColor = 'currentColor',
  } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox={viewBox}
      preserveAspectRatio="xMidYMid meet"
    >
      <g
        transform="translate(-12.25,-11.25) scale(0.05,-0.05) translate(0,-960)"
        fill={fillColor}
        stroke="none"
      >
        <path d="M552 690 c21 -6 53 -26 72 -44 33 -30 35 -31 38 -12 2 12 10 21 18 21 11 0 16 -14 18 -58 l3 -58 -57 3 c-59 3 -86 24 -45 35 33 8 21 25 -39 56 -43 22 -64 27 -98 24 -60 -6 -115 -46 -141 -101 -24 -53 -51 -62 -51 -18 0 44 51 106 111 136 57 28 109 33 171 16z" />
        <path d="M498 537 c3 -34 6 -36 40 -39 25 -2 37 -8 37 -18 0 -10 -12 -16 -37 -18 -35 -3 -37 -5 -40 -40 -4 -51 -32 -51 -36 0 -3 35 -5 37 -40 40 -51 4 -51 32 1 36 35 3 37 5 37 36 0 59 33 62 38 3z" />
        <path d="M690 422 c0 -44 -51 -106 -111 -136 -86 -42 -180 -32 -243 28 -33 30 -35 31 -38 12 -2 -12 -10 -21 -18 -21 -11 0 -16 14 -18 58 l-3 58 57 -3 c59 -3 86 -24 45 -35 -28 -7 -26 -18 7 -41 99 -70 222 -42 271 62 24 53 51 62 51 18z" />
      </g>
    </svg>
  );
};

export default YouTubeRemixIcon;
